import { MessageText } from "../../constants/constants.js";

const TEXT = MessageText.statusScreens.upcoming;

const PLACEHOLDER_SPEAKERS = [
  { id: 1, name: "Dr. Jane Doe", designation: "Cardiologist" },
  { id: 2, name: "Dr. John Smith", designation: "Neurologist" },
];

function CountdownUnit({ value, label }) {
  return (
    <div className="flex flex-col items-center bg-[var(--primary-color)] text-white rounded-lg px-4 py-3 min-w-[70px]">
      <span className="text-2xl lg:text-3xl font-bold">{String(value).padStart(2, "0")}</span>
      <span className="text-xs opacity-80 mt-0.5">{label}</span>
    </div>
  );
}

export default function UpcommingScreen({
  title = TEXT.title,
  description = TEXT.description,
  dateTimeText = "Monday, January 12, 2026 at 10:00 AM",
  countdown = { days: 2, hours: 14, minutes: 32, seconds: 8 },
  speakers = PLACEHOLDER_SPEAKERS,
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 lg:p-8">
      <div className="max-w-2xl w-full">
        <div className="mb-6 rounded-xl overflow-hidden shadow-lg">
          <div className="w-full h-56 max-h-80 bg-gray-200 flex items-center justify-center text-gray-400 text-sm font-medium">
            Session Poster
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 lg:p-8 text-center">
          <div className="text-xl lg:text-2xl font-bold text-gray-900 mb-3">{title}</div>

          <div className="text-gray-600 leading-relaxed mb-4 text-sm lg:text-base">{description}</div>

          <div className="mb-6">
            <p className="text-sm text-gray-500 font-medium mb-3">{TEXT.startsInLabel}</p>
            <div className="flex justify-center gap-3">
              {countdown.days > 0 && <CountdownUnit value={countdown.days} label="Days" />}
              <CountdownUnit value={countdown.hours} label="Hours" />
              <CountdownUnit value={countdown.minutes} label="Min" />
              <CountdownUnit value={countdown.seconds} label="Sec" />
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{dateTimeText}</span>
          </div>
        </div>

        {speakers?.length > 0 && (
          <div className="mt-6">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Speakers</h3>
            <div className="flex gap-4 overflow-x-auto pb-2">
              {speakers.map((speaker) => (
                <div key={speaker.id} className="flex items-center gap-3 bg-white rounded-lg p-3 shadow-sm min-w-[250px]">
                  <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-400 shrink-0">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{speaker.name}</p>
                    <p className="text-xs text-gray-500">{speaker.designation}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
